module.exports = __webpack_public_path__ + "img/开盒记录按钮.b986c527.png";